import React, { useMemo } from "react";

export function isEmptyCellValue(value) {
  if (value == null || typeof value === "boolean") return true;
  if (typeof value === "string") return value.trim() === "";
  if (Array.isArray(value)) return value.every(isEmptyCellValue);
  if (!React.isValidElement(value)) return false;
  if (value.type?.isEmptyCellContent === true) return true;
  if (value.type === React.Fragment) return isEmptyCellValue(value.props?.children);

  if (typeof value.type === "function" && !value.type.prototype?.isReactComponent) {
    try {
      return isEmptyCellValue(value.type(value.props));
    } catch {
      return false;
    }
  }

  if ((typeof value.type === "string" || typeof value.type === "object") && "children" in (value.props ?? {})) {
    return isEmptyCellValue(value.props.children);
  }

  return false;
}

export function getVisibleTableColumns(columns, rows) {
  const visible = (columns ?? []).filter((column) => column?.hidden !== true);
  if (!rows?.length) return visible;

  return visible.filter((column) => {
    if (column?.hideWhenEmpty !== true) return true;
    return rows.some((row, rowIdx) => {
      const value = column.render ? column.render(row, rowIdx) : row?.[column.accessor];
      return !isEmptyCellValue(value);
    });
  });
}

export function useVisibleTableColumns(columns, rows) {
  return useMemo(() => getVisibleTableColumns(columns, rows), [columns, rows]);
}
